<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Create pharmacy</h1>

            <!-- <span class="mainDescription"
              >Use this page to start from scratch and put your custom
              content</span
            > -->
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-pharmacies' }">Back</router-link>
          </div>
          <!-- <ol class="breadcrumb">
            <li class="active">
              <span>Blank Page</span>
            </li>
          </ol> -->
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <form class="text-start mx-auto" @submit.prevent="createPharmacy" enctype="multipart/form-data">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="text-">English Name</label>
                    <input type="text" class="form-control" placeholder="Enter English Name" v-model="name_en" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="labName">Arabic Name</label>
                    <input type="text" class="form-control" placeholder="Enter Arabic Name" v-model="name_ar" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label class="text-">English Title</label>
                    <input type="text" class="form-control" placeholder="Enter English Title" v-model="title_en" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="labTitle">Arabic Title</label>
                    <input type="text" class="form-control" placeholder="Enter Arabic Title" v-model="title_ar" />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="labName">English Description </label>
                    <textarea rows="3" class="form-control" placeholder="Enter English Description"
                      v-model="description_en"></textarea>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="labName">Arabic Description </label>
                    <textarea rows="3" class="form-control" placeholder="Enter Arabic Description"
                      v-model="description_ar"></textarea>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="pharmacyName">English Address</label>
                    <input type="text" class="form-control" placeholder="Enter address" v-model="address_en" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="pharmacyName">Arabic Address</label>
                    <input type="text" class="form-control" placeholder="Enter address" v-model="address_ar" />
                  </div>
                </div>

                <!-- for creating new user -->
                <div class="col-md-12 mb-3">
                  <div class="form-group">
                    <label for="email">Email</label>
                    <input type="email" class="form-control" placeholder="Enter email" v-model="email" />
                  </div>
                </div>


                <GoogleMap :coords="{ lat: lat, lng: long }" @placeChanged="handlePlaceChanged" />
                <div class="form-group">
                  <label>Latitude</label>
                  <input type="text" class="form-control" placeholder="Enter Latitude" v-model="lat" />
                </div>

                <div class="form-group">
                  <label>Longitude</label>
                  <input type="text" class="form-control" placeholder="Enter Longitude" v-model="long" />
                </div>

                <div class="form-group col-4">
                  <label>from</label>
                  <input type="time" class="form-control" placeholder="Enter Time" v-model="from" />
                  <span class="error text-small block" v-if="errors.from">{{
                    errors.from }}</span>
                </div>
                <div class="form-group col-4">
                  <label>to</label>
                  <input type="time" class="form-control" placeholder="Enter Time" v-model="to" />
                  <span class="error text-small block" v-if="errors.to">{{
                    errors.to }}</span>
                </div>

                <div class="form-group col-4">
                  <label>Experience</label>
                  <input type="number" class="form-control" placeholder="Enter Experience" v-model="experience" />
                  <span class="error text-small block" v-if="errors.experience">{{
                    errors.experience }}</span>
                </div>
                <div class="form-group col-md-3">
                  <div class="checkbox clip-check check-primary">
                    <input type="checkbox" v-model="pickup" id="service1">
                    <label for="service1">
                      Pickup
                    </label>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <div class="checkbox clip-check check-primary">
                    <input type="checkbox" v-model="delivery" id="service2">
                    <label for="service2">
                      Delivery
                    </label>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label class="text-">Delivery Fees</label>
                  <input type="number" class="form-control" placeholder="Enter Delivery Fees" v-model="delivery_fees" />
                </div>
                <div class="form-group col-md-3">
                  <label class="text-">Delivery Time</label>
                  <input type="number" class="form-control" placeholder="Enter Delivery Time" v-model="delivery_time" />
                </div>
                <div class="form-group col-5">
                  <label>Phone</label>
                  <input type="text" class="form-control" placeholder="Enter Phone" v-model="phone" />
                </div>
                <div class="form-group col-5">
                  <label>Url</label>
                  <input type="text" class="form-control" placeholder="Enter Url" v-model="url" />
                </div>
                <div class="form-group">
                  <label> Image Upload </label>
                  <div class="fileinput fileinput-new" data-provides="fileinput">
                    <div class="fileinput-new thumbnail">
                      <!-- <img src="/assets/images/avatar-1-xl.jpg" alt="" /> -->
                    </div>
                    <div class="fileinput-preview fileinput-exists thumbnail"></div>
                    <div class="user-edit-image-buttons">
                      <span class="btn btn-azure btn-file"><span class="fileinput-new"><i class="fa fa-picture"></i>
                          Select image</span><span class="fileinput-exists"><i class="fa fa-picture"></i> Change</span>
                        <input type="file" name="main_image" @change="handleMainImageChange" ref="imageInput" />
                      </span>
                      <a href="#" class="btn fileinput-exists btn-red" data-dismiss="fileinput"
                        @click.prevent="clearImage">
                        <i class="fa fa-times"></i> Remove
                      </a>
                    </div>
                  </div>
                  <span class="error text-small block" v-if="errors.main_image">{{
                    errors.main_image }}</span>
                </div>
                <div class="form-group">
                  <label> Backgroud Image Upload </label>
                  <div class="fileinput fileinput-new" data-provides="fileinput">
                    <div class="fileinput-new thumbnail">
                      <!-- <img src="/assets/images/avatar-1-xl.jpg" alt="" /> -->
                    </div>
                    <div class="fileinput-preview fileinput-exists thumbnail"></div>
                    <div class="user-edit-image-buttons">
                      <span class="btn btn-azure btn-file"><span class="fileinput-new"><i class="fa fa-picture"></i>
                          Select background_image</span><span class="fileinput-exists"><i class="fa fa-picture"></i>
                          Change</span>
                        <input type="file" name="background_image" @change="handleBackgroundImageChange"
                          ref="backgroundImageInput" />
                      </span>
                      <a href="#" class="btn fileinput-exists btn-red" data-dismiss="fileinput"
                        @click.prevent="clearBackgroundImage">
                        <i class="fa fa-times"></i> Remove
                      </a>
                    </div>
                  </div>
                  <span class="error text-small block" v-if="errors.background_image">{{
                    errors.background_image }}</span>
                </div>
                <div class="form-group">
                  <label>Additional Images</label>
                  <div class="multiple-image-upload">
                    <div class="upload-container">
                      <input type="file" class="form-control" accept="image/*" multiple @change="handleMultipleImages"
                        ref="multipleImages" />
                    </div>
                    <!-- Preview section -->
                    <div v-if="imagePreviewUrls.length" class="image-preview-container">
                      <h5>Selected Images:</h5>
                      <div class="row g-3">
                        <div v-for="(preview, index) in imagePreviewUrls" :key="index" class="col-md-3 col-sm-4 col-6">
                          <div class="image-preview-wrapper">
                            <img :src="preview" alt="Preview" class="img-thumbnail preview-image"
                              @click="removeImage(index)" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group ">
                  <label class="text-">District</label>
                  <multiselect v-model="selectedDistrict" :options="districts" :searchable="true" label="name"
                    track-by="id" placeholder="Select a District" :multiple="false"></multiselect>
                  <span class="error text-small block" v-if="errors.selectedDistrict">{{
                    errors.selectedDistrict }}</span>
                </div>
                <div class="form-group">
                  <label class="text-">Medical Insurances</label>
                  <multiselect v-model="selectedMedicalInsurance" :options="medicalInsurances" :searchable="true"
                    label="name_en" track-by="id" placeholder="Select Insurances" :multiple="true"></multiselect>
                </div>

              </div>
              <button class="btn btn-primary">Submit</button>
            </form>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
import GoogleMap from "../Component/GoogleMap.vue";
import Multiselect from "vue-multiselect";
import { store } from "../../Store";
export default {
  name: "createPharmacy",
  components: {
    Multiselect,
    GoogleMap,
  },
  data() {
    return {
      name_en: "",
      name_ar: "",
      description_en: "",
      description_ar: "",
      title_ar: "",
      title_en: "",
      password: "",
      email: "",
      experience: "",
      from: "",
      to: "",
      address: "",
      phone: "",
      url: "",
      pickup: false,
      delivery: false,
      address_ar: "",
      address_en: "",
      delivery_fees: "",
      delivery_time: "",
      lat: 30.0444, // Lat and long for input fields
      long: 31.2357, // long and long for input fields
      service_id: 24,
      user_id: "",
      districts: [],
      selectedDistrict: "",

      medicalInsurances: [],
      selectedMedicalInsurance: [],

      main_image: null,
      background_image: null,

      additionalImages: [], // For storing File objects
      imagePreviewUrls: [], // For storing preview URLs
      // maxImages: 10, // Maximum number of images allowed

      errors: {},

    };
  },
  created() {
    this.fetchDistrict();
    this.fetchMedicalInsurances();
  },
  methods: {
    handlePlaceChanged({ lat, lng }) {
      this.lat = lat;
      this.long = lng;
    },

    handleMainImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.main_image = file;
      }
      // event.target.value = null;
    },
    handleBackgroundImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.background_image = file;
      }
      // event.target.value = null;
    },
    clearImage() {
      this.main_image = null;
      this.$refs.imageInput.value = ''; // Clear the file input
    },
    clearBackgroundImage() {
      this.background_image = null;
      this.$refs.backgroundImageInput.value = ''; // Clear the file input
    },
    handleMultipleImages(event) {
      const files = Array.from(event.target.files);
      // // Check if total images would exceed maximum
      // if (this.additionalImages.length + files.length > this.maxImages) {
      //   alert(`You can only upload up to ${this.maxImages} images`);
      //   return;
      // }

      // Process each selected file
      files.forEach(file => {
        if (file.type.startsWith('image/')) {
          // Create preview URL
          const reader = new FileReader();
          reader.onload = (e) => {
            this.imagePreviewUrls.push(e.target.result);
          };
          reader.readAsDataURL(file);

          // Store file object
          this.additionalImages.push(file);
        }
      });
      // Reset input to allow selecting the same files again
      event.target.value = '';
    },

    removeImage(index) {
      this.additionalImages.splice(index, 1);
      this.imagePreviewUrls.splice(index, 1);
    },
    getDistrictId() {
      const districtId = this.selectedDistrict.id;
      return districtId;
    },
    async fetchDistrict() {
      try {
        const response = await axios.get("/admin/admin/district/all");
        this.districts = response.data.data;
      } catch (error) {
        console.error(error);
      }
    },
    async fetchMedicalInsurances() {
      try {
        const response = await axios.get("/admin/admin/medical-insurance/all");
        this.medicalInsurances = response.data.data;
        this.meta = response.data.meta;
      } catch (error) {
        console.error(error);
      }
    },
    validateForm() {
      this.errors = {};

      // experience validation
      if (!this.experience) {
        this.errors.experience = "['Experience is required.']";
      }
      // from validation
      if (!this.from) {
        this.errors.from = "['From is required.']";
      }
      // to validation
      if (!this.to) {
        this.errors.to = "['To is required.']";
      }

      // selectedDistrict validation
      if (!this.selectedDistrict) {
        this.errors.selectedDistrict = "['District is required.']";
      }
      // Image validation
      if (this.main_image && !['image/jpeg', 'image/jpg', 'image/png'].includes(this.main_image.type)) {
        this.errors.main_image = "['Image must be a JPEG, JPG, or PNG file.']";
      }
      // Image validation
      if (this.background_image && !['image/jpeg', 'image/jpg', 'image/png'].includes(this.background_image.type)) {
        this.errors.background_image = "['Image must be a JPEG, JPG, or PNG file.']";
      }
      return Object.keys(this.errors).length === 0;
    },
    async createPharmacy() {
      try {
        if (!this.validateForm()) {
          return; // Stop if validation fails
        }
        const district_id = this.getDistrictId();

        const formData = new FormData();
        formData.append("name_en", this.name_en);
        formData.append("name_ar", this.name_ar);
        formData.append("description_en", this.description_en);
        formData.append("description_ar", this.description_ar);
        formData.append("email", this.email);
        formData.append("password", this.password);
        formData.append("latitude", this.lat);
        formData.append("longitude", this.long);
        // formData.append("address", this.address);
        formData.append("address_en", this.address_en);
        formData.append("address_ar", this.address_ar);
        formData.append("delivery_fees", Number(this.delivery_fees));
        formData.append("delivery_time", Number(this.delivery_time));
        formData.append("experience", this.experience);
        formData.append("from", this.from);
        formData.append("to", this.to);
        formData.append("phone", this.phone);
        formData.append("url", this.url);
        formData.append("pickup", this.pickup ? 1 : 0);
        formData.append("delivery", this.delivery ? 1 : 0);
        formData.append("title_ar", this.title_ar);
        formData.append("title_en", this.title_en);
        formData.append("service_id", 24);
        formData.append("district_id", district_id);

        const user_id = store.user ? store.user.id : null;
        formData.append("user_id", user_id);

        this.selectedMedicalInsurance.forEach((medicalInsurance, index) => {
          formData.append(`medical_insurance[${index}]`, medicalInsurance.id);
        });

        if (this.background_image) {
          formData.append("background_image", this.background_image);
        }
        if (this.main_image) {
          formData.append("main_image", this.main_image);
        }
        this.additionalImages.forEach((image) => {
          formData.append(`new_images[]`, image);
        });
        // this.selectedImages.forEach((file, index) => {
        //   formData.append(`images[${index}]`, file);
        // });
        // this.additionalImages.forEach((image, index) => {
        //   formData.append(`images[]`, image);  // Changed from images[${index}] to images[]
        // });

        const response = await axios.post(
          "admin/admin/pharmacy/create",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log(response.data);
        this.$router.push({ name: "all-pharmacies" });
      } catch (error) {
        console.error(error);
        if (error.response && error.response.data.errors) {
          // Map backend errors to the errors object
          this.errors = error.response.data.errors;
        }
      }
    },
  },
};
</script>


<style scoped>
form {
  padding: 1rem;
  border: 1px solid #ccc;
  background-color: white;
  /* Add a background color */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* Add a shadow for better visibility */
  width: 100%;
  /* max-width: 500px; Optional: Max width for better responsiveness */
}

.error {
  color: #a94442;
  font-size: 0.875em;
}

form>.form-group {
  margin-bottom: 1.5rem;
}

button {
  width: 100%;
}

.multiple-image-upload {
  margin-bottom: 1.5rem;
}

.image-preview-container {
  margin-top: 1rem;
}

.image-preview-wrapper {
  position: relative;
  margin-bottom: 1rem;
}

.preview-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.remove-image {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 2px 8px;
  font-size: 12px;
}

.upload-container {
  margin-bottom: 1rem;
}
</style>
